import React, { useEffect, useRef, useState } from "react";
import {
  I2cHeader,
  I2cBrand,
  I2cIcon,
  I2cButton,
  I2cMenubar,
  I2cMegaMenu,
  I2cListGroup,
  I2cListItem,
  I2cAvatar,
  I2cIconButton,
  I2cDropdown,
  I2cMenuItem,
  I2cMenu,
  I2cDivider,
  I2cDrawer,
  I2cActivityFeeds,
  I2cActivityFeedItem,
  I2cSelect,
} from "@webcomponents/i2cwebcomponents/dist/react";
import logo from "../../assets/images/i2c_logo.svg";
import { QueryClient } from "react-query";
import avatar from "../../assets/images/avatar-main.svg";
import avatarSecondary from "../../assets/images/avatar.svg";
import { useNavigate, useLocation } from "react-router-dom";
import AuthService from "../../Services/AuthServices";
import { useQuery } from "react-query";
import { OverlayLoader } from "../Loader/Loader";
import UserManagmentService from "../../Services/UsermanagmentService";
import DarkModeBtn from "../DarkModeBtn/DarkModeBtn";
import "./SecureHeader.scss";
import { UserStateContext } from "../../Context/AuthContext";
const SecureHeader = () => {
  const [open, setNotificationOpen] = useState(false);
  const [openSupport, setSupportOpen] = useState(false);
  const [notificationList, setNotificationList] = useState([]);
  const [loading, setLoading] = useState(false);
  const classFooter = "drawer--file-footer";
  const appContext = UserStateContext();
  const queryClient = new QueryClient();
  const location = useLocation();
  const navigate = useNavigate();
  const [showTab, setShowTab] = useState(true);

  const userRole = appContext.userRole;
  const header = {
    logo: {
      "--brand-logo-img-width": "2.5rem",
      "--brand-logo-img-height": "auto",
    },
    footer: {},
    lighList: {
      "--list-text-color": "var(--i2c-color-gray-500)",
      "--list-item-external-gap": "var(--i2c-spacing-3)",
      "--list-item-inline-gap": "0",
      "--list-item-block-gap": "0",
      "--list-radius": "0",
    },
    alert: {
      "--footer-spacing": "0.813",
    },
    alertImg: {
      "margin-block": "0.938rem",
      width: "100%",
    },
    alertFooter: {
      display: "flex",
      gap: "0.938rem",
    },
    customSidebarMenu: {
      display: "inline-block",
      border: "1px solid var(--i2c-color-gray-200)",
      width: "20rem",
      "padding-inline": "var(--i2c-spacing-4)",
      paddingBlock: "var(--i2c-spacing-8)",
      position: "relative",
    },
    miscSearchIcon: {
      fontSize: "1.25rem",
    },
    avatartBlockGap: {
      paddingBlock: "0",
    },
  };
  const {
    data: user,
    isLoading,
    refetch: refetchUserProfile,
    remove,
  } = useQuery("userProfile", () => UserManagmentService.getUserProfile(), {
    refetchOnWindowFocus: false,
    staleTime: 300000,
  });

  const {
    data: notifications,
    isFetching,
    // remove,
  } = useQuery("notifications", () => UserManagmentService.getNotifications(), {
    refetchOnWindowFocus: false,
  });
  useEffect(() => {
    if (userRole == 5) {
      setShowTab(false);
    } else {
      setShowTab(true);
    }
  }, [userRole]);

  useEffect(() => {
    if (notifications) {
      setNotificationList(notifications?.data?.notifications);
    }
  }, [notifications]);

  const profileData = user?.data?.data?.user;
  
  const [showSecureItems, setSecureItems] = useState(true);

  useEffect(() => {
    const showSecureItem = location.pathname.includes("concurrent-sessions")
      ? false
      : true;
    setSecureItems(showSecureItem);
  }, [location.pathname]);

  useEffect(() => {
    localStorage.setItem("role", profileData?.role_name ?? "");
  }, [user]);

  const supportNoti = [
    {
      title: " Help and Support",
      desc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Odio dictumst tempus magna elit cras posuere cursus pulvinar id. Facilisis at eu amet ornare enim arcu malesuada rutrum a.",
      placeholder: "",
    },
    {
      title: " Help and Support",
      desc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Odio dictumst tempus magna elit cras posuere cursus pulvinar id. Facilisis at eu amet ornare enim arcu malesuada rutrum a.",
      placeholder: "",
    },
  ];
  useEffect(() => {
    refetchUserProfile();
  }, [localStorage.getItem("token")]);

  const handleLogout = () => {
    setLoading(true);
    AuthService.logout()
      .then((res) => {
        localStorage.removeItem("token");
        localStorage.removeItem("session");
        localStorage.removeItem("role");
        localStorage.removeItem("userRole");
        navigate("/login");
        remove();
      })
      .catch((e) => console.log(e))
      .finally(() => setLoading(false));
  };
  function handleRequestClose(event) {
    if (event.detail.source === "overlay") {
      event.preventDefault();
    }
  }
  function handleSupportRequestClose(event) {
    if (event.detail.source === "overlay") {
      event.preventDefault();
    }
  }
  const handleItemClick = (formType, formId) => {
    if (formType === 1) {
      navigate(`/debit/edit/${formId}`);
    } else {
      navigate(`/credit/edit/${formId}`);
    }
  };

  const superAdminUser = profileData?.role_name === "super_admin";
  const adminUser = profileData?.role_name === "admin";
  const clientUser =
    localStorage.getItem("role") === "client" ??
    profileData?.role_name === "client";
  return (
    <>
      {loading && <OverlayLoader />}
      {/* <OverlayLoader /> */}
      <div part={"i2c-header"}>
        <I2cHeader
          id="basicHeader1"
          className="header-container"
          responsive
          toggle-align="start"
          secure
          bend
        >
          <I2cBrand
            className="secureHeaderLogo"
            slot="brand"
            logo={logo}
            target=""
            style={header.logo}
            label=""
          ></I2cBrand>
          {(showTab || userRole != 5) && (
            <div slot="items" className="secureHeaderItems">
              {showSecureItems && (
                <I2cMenubar id="basicHeaderMenuBar1">
                  <I2cButton
                    onClick={() => navigate("/sales")}
                    variant={
                      window.location.pathname.includes("sales")
                        ? "secondary color"
                        : "tertiary gray"
                    }
                    className={
                      window.location.pathname.includes("sales")
                        ? "secondary-color"
                        : ""
                    }
                    menu-btn
                    size="medium"
                  >
                    Sales Queue
                  </I2cButton>
                  <I2cButton
                    onClick={() => navigate("/impl")}
                    variant={
                      window.location.pathname.includes("impl")
                        ? "secondary color"
                        : "tertiary gray"
                    }
                    className={
                      window.location.pathname.includes("impl")
                        ? "secondary-color"
                        : ""
                    }
                    size="medium"
                    menu-btn
                  >
                    Imp. Queue
                  </I2cButton>
                  {(adminUser || superAdminUser) && (
                    <I2cButton
                      onClick={() => {
                        navigate("/users");
                      }}
                      menu-btn
                      variant={
                        window.location.pathname.includes("users")
                          ? "secondary color"
                          : "tertiary gray"
                      }
                      className={
                        window.location.pathname.includes("users")
                          ? "secondary-color"
                          : ""
                      }
                      size="medium"
                    >
                      User Management
                    </I2cButton>
                  )}
                </I2cMenubar>
              )}
            </div>
          )}
          <div slot="misc" className="secureHeaderMisc">
            <DarkModeBtn />
            {/*{showSecureItems && (*/}
            {/*  <I2cIconButton*/}
            {/*    onClick={() => setSupportOpen(true)}*/}
            {/*    name={"cs-linear-help-circle"}*/}
            {/*    label={"Edit"}*/}
            {/*    style={header.miscSearchIcon}*/}
            {/*  ></I2cIconButton>*/}
            {/*)}*/}
            {showSecureItems && (
              <I2cIconButton
                onClick={() => setNotificationOpen(true)}
                name={"linear-notification-bing"}
                label={"Notification"}
                style={header.miscSearchIcon}
              ></I2cIconButton>
            )}

            <I2cDropdown
              foot
              distance="16"
              placement="bottom-end"
              // disabled={loading}
              head
              className="header_dropdown"
              width="calc(var(--i2c-spacing-56) + var(--i2c-spacing-6))"
            >
              <I2cAvatar
                style={header.avatartBlockGap}
                image={
                  `data:image/jpeg;base64,${profileData?.avatar}` ??
                  "../assets/images/avatar.svg"
                }
                label={profileData?.email ?? "-"}
                slot="trigger"
                size="large"
              ></I2cAvatar>
              {loading && <OverlayLoader hideSpinner={true} />}
              <div slot="head">
                <div className="userTitle">{profileData?.name ?? "-"}</div>
                <div className="userEmail">{profileData?.email ?? "-"}</div>
              </div>
              <I2cMenu
                className="auth-dropdown-header"
                style={{ zIndex: "auto" }}
              >
                <I2cMenuItem
                  disabled={loading}
                  size="large"
                  onClick={() => !loading && navigate("/profile")}
                  value="profile"
                >
                  <I2cIcon slot="prefix" name="linear-profile-circle"></I2cIcon>
                  View Profile
                </I2cMenuItem>
              </I2cMenu>
              <div slot="foot">
                <I2cMenuItem
                  disabled={loading}
                  onClick={() => !loading && handleLogout()}
                >
                  <I2cIcon
                    slot="prefix"
                    name="linear-logout-1"
                    className="error-icon-header"
                  ></I2cIcon>
                  Logout
                </I2cMenuItem>
              </div>
            </I2cDropdown>
          </div>
        </I2cHeader>
      </div>
      {/* Notification Drawer */}
      <I2cDrawer
        label="Notifications"
        sub-label=""
        open={open}
        onI2cRequestClose={handleRequestClose}
        onI2cAfterHide={() => setNotificationOpen(false)}
        className="drawer-activity-feed"
      >
        {notificationList.length != "" ? (
          <>
            <I2cActivityFeeds
              variant="divider"
              type="notification"
              className="i2c-activity-feeds cursor_notification"
            >
              {notificationList.map((data, index) => (
                <I2cActivityFeedItem
                  key={index}
                  label={data.assigner.name}
                  time={data.created_at}
                  events={data.message}
                  onClick={() =>
                    handleItemClick(data?.form?.type, data?.form?.id)
                  }
                >
                  <I2cAvatar
                    style={header.avatartBlockGap}
                    image={
                      `data:image/jpeg;base64,${data?.assigner?.avatar?.avatar}` ??
                      "../assets/images/avatar.svg"
                    }
                    label={profileData?.email ?? "-"}
                    slot="feed-avatar"
                    size="large"
                  ></I2cAvatar>
                </I2cActivityFeedItem>
              ))}
            </I2cActivityFeeds>
          </>
        ) : (
          <>
            <div className="no-notification-container">
              <div className="notify-container">
                <I2cIcon
                  className="cs-icon-shadowed"
                  variant="shadowed"
                  name="linear-info-circle"
                />
                <div className="no-user-title">No New Notifications</div>
              </div>
            </div>
          </>
        )}
      </I2cDrawer>
      {/* Help & Support Drawer          */}
      <I2cDrawer
        label="Help and Support"
        sub-label=""
        open={openSupport}
        onI2cRequestClose={handleSupportRequestClose}
        onI2cAfterHide={() => setSupportOpen(false)}
        ref={I2cDrawer}
      >
        <I2cActivityFeeds
          variant=""
          type="notification"
          className="i2c-activity-feeds"
        >
          {supportNoti.map((data, index) => (
            <div key={index} className="hs-listing">
              <div className="hs-subtitle">{data.title}</div>
              <p className="hs-text">{data.desc}</p>
              <div className="hs-placeholder">{data.placeholder}</div>
            </div>
          ))}
        </I2cActivityFeeds>
      </I2cDrawer>
    </>
  );
};

export default SecureHeader;
